import React, { useState, useEffect, useRef } from "react";

// Core Swiper modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Thumbs, Controller, A11y, EffectFade } from 'swiper/modules';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation'; // Optional, if you want navigation arrows
import 'swiper/css/pagination';  // Optional, if you want pagination dots for images
import 'swiper/css/thumbs';      // For connecting two swipers
import 'swiper/css/effect-fade'; // For fade effect on text

// Data for slides (assuming this structure or adapt as needed)
const tabContents = [
    {
        iconClass: "fa fa-align-left",
        title: "Page Change Effects",
        text: "The transition between pages is made to provide convenience for users while navigating.",
        image: require('../../../assets/images/aeroland/tab-content-image-04.jpg')
    },
    {
        iconClass: "fa fa-rocket",
        title: "New Marketing Plan",
        text: "We are capable of sketching out competitive marketing plans that's efficiency proven. This plan includes several key areas for growth and market penetration.",
        image: require('../../../assets/images/aeroland/tab-content-image-05.jpg')
    },
    {
        iconClass: "fa fa-chart-pie",
        title: "SEO Analytic Tools",
        text: "Promote your sales and increase the ROI with the help from built-in SEO analytics tools. These tools offer deep insights.",
        image: require('../../../assets/images/aeroland/tab-content-image-06.jpg')
    }
];

const TabsThree = () => {
    // State to hold the thumbs Swiper instance (for text slider to control image slider)
    // And state for the main image swiper (for text slider to be controlled by image slider - more common)
    const [textSwiper, setTextSwiper] = useState(null);
    const [imageSwiper, setImageSwiper] = useState(null);

    return (
        // The .text-gray class here is important for SCSS targeting for themes
        <div className="tabs-three-area tab-style--2 ptb--120 text-gray">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4"> {/* This becomes col-12 on mobile */}
                        <div className="tab-content-wrapper swiper-text-wrapper">
                            <Swiper
                                modules={[Controller, A11y, EffectFade]}
                                // Vertical mode for text
                                direction="vertical"
                                slidesPerView={1}
                                spaceBetween={0} // No space if slides are full height
                                effect="fade" // Fade effect for text changes
                                fadeEffect={{ crossFade: true }}
                                autoHeight={true} // Key for adaptive height for text slides
                                loop={false} // Loop can sometimes complicate autoHeight, test carefully
                                onSwiper={setTextSwiper} // Set textSwiper instance
                                controller={{ control: imageSwiper }} // Controlled by imageSwiper
                                className="testimonial-image-slider swiper-text-slider" // Keep class for potential styling
                                // Prevent swiping if it's meant to be controlled only by image nav
                                allowTouchMove={false} 
                            >
                                {tabContents.map((content, index) => (
                                    <SwiperSlide key={index} className="swiper-slide-text-content">
                                        <div className="tab2-content">
                                            <div className="title">
                                                <i className={content.iconClass} />
                                                <h4>{content.title}</h4>
                                            </div>
                                            <p>{content.text}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                    <div className="col-lg-8 mt_lg--0 mt_md--40 mt_sm--40"> {/* Ensure no top margin on lg for side-by-side */}
                        <div className="tab2-thumbnail-wrapper swiper-image-wrapper">
                            <Swiper
                                modules={[Controller, A11y, Pagination, Thumbs]} // Added Thumbs
                                spaceBetween={10} // Optional space between image thumbnails if you had them
                                slidesPerView={1}
                                loop={false}
                                pagination={{ clickable: true }} // Standard dots pagination for images
                                onSwiper={setImageSwiper} // Set imageSwiper instance
                                controller={{ control: textSwiper }} // Controls textSwiper
                                // thumbs={{ swiper: textSwiperInstanceForThumbs }} // If text were thumbnails
                                className="testimonial-text-slider swiper-image-slider" // Keep class for potential styling
                            >
                                {tabContents.map((content, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="thumbnail">
                                            <img src={content.image} alt={content.title} />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TabsThree;